/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

export default class Envelope extends EmberObject {
  nominalValuesArray;
  simulatedValues;
  @computed('nominalValuesArray', 'simulatedValues') get minimumValues() {
    var nominalValuesArray = this.nominalValuesArray;
    var simulatedValues = this.simulatedValues;
    simulatedValues.push(nominalValuesArray);
    var result = [];

    for (var i = 0; i < nominalValuesArray; i++) {
      var valuesOnTheSameIndex = [];
      for (var j = 0; j < simulatedValues; j++) {
        valuesOnTheSameIndex.push(simulatedValues[j][i]);
      }

      result[i] = Math.min(valuesOnTheSameIndex);
    }

    return result;
  }

  @computed('nominalValuesArray') get nominalValues() {
    return this.nominalValuesArray;
  }

  @computed('nominalValuesArray', 'simulatedValues') get maximumValues() {
    var nominalValuesArray = this.nominalValuesArray;
    var simulatedValues = this.simulatedValues;
    simulatedValues.push(nominalValuesArray);
    var result = [];

    for (var i = 0; i < nominalValuesArray; i++) {
      var valuesOnTheSameIndex = [];
      for (var j = 0; j < simulatedValues; j++) {
        valuesOnTheSameIndex.push(simulatedValues[j][i]);
      }

      result[i] = Math.max(valuesOnTheSameIndex);
    }

    return result;
  }
}
